import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  allow403?: boolean;
}

export const getBusinessInformation = () => {
  return axiosPrivate.get(`/dashboard/api/v1/business_information/retrieve`);
};

export const updateBusinessInformation = (formData: FormData) => {
  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  return axiosPrivate.put(`/dashboard/api/v1/business_information/update`, formData, { headers: headers, allow403: true } as CustomAxiosRequestConfig);
};
